import { useRouter } from 'next/router';

import { CountryDetails, CountryProps, CountryCode } from '@pflegia/types/common/shared/country';

/**
 * hook to get the country code from the locale
 * @return the code and name of the current country
 */
export const useGetCountryDetails = (): Pick<CountryProps, 'code' | 'name'> => {
  const { locale } = useRouter();
  const countryCode = locale?.split('-')?.reverse()[0]?.toUpperCase() as CountryCode | undefined;

  return CountryDetails[countryCode || 'DE'];
};
